import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Navbar.css";
import { Button } from "../Button/Button";

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const [hideNavbar, setHideNavbar] = useState(false);
  const { t, i18n } = useTranslation();

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();

    const handleResize = () => showButton();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setHideNavbar(true);
        setClick(false);
      } else {
        setHideNavbar(false);
      }

      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleLanguage = () => {
    const newLang = i18n.language === "de" ? "en" : "de";
    i18n.changeLanguage(newLang);
  };

  return (
    <>
      <nav className={hideNavbar ? "navbar navbar-hidden" : "navbar"}>
        <div className="navbar-container">
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            <img
              src="/images/logo/navbar-logo.png"
              alt="Onenizer Logo"
              className="navbar-logo-img"
            />
          </Link>

          <div className="menu-icon" onClick={handleClick}>
            <i className={click ? "fas fa-times" : "fas fa-bars"} />
          </div>

          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <Link to="/" className="nav-links" onClick={closeMobileMenu}>
                {t("navbar.home")}
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/app" className="nav-links" onClick={closeMobileMenu}>
                {t("navbar.app")}
              </Link>
            </li>

            <li className="nav-item">
              <Link
                to="/contact"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                {t("navbar.contact")}
              </Link>
            </li>
            <li>
              <button className="nav-links-mobile" onClick={toggleLanguage}>
                {i18n.language === "de" ? "DE" : "EN"}
              </button>
            </li>
          </ul>

          <div className="navbar-actions">
            <button className="lang-switch-btn" onClick={toggleLanguage}>
              {i18n.language === "de" ? "DE" : "EN"}
            </button>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
